import { useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import api from "api/axios";

function MotDePasseOublie() {
  const [email, setEmail] = useState("");
  const [envoye, setEnvoye] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    if (!email) {
      setError("Merci de saisir votre email.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/mot-de-passe-oublie", { email });
      setEnvoye(true);
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBox
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#f0f2f5" }}
    >
      <Card sx={{ width: 400, p: 3 }}>
        <MDBox textAlign="center" mb={3}>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1976d2" }}>
            Gestion SI
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Mot de passe oublié
          </MDTypography>
        </MDBox>

        {envoye ? (
          <MDBox textAlign="center" py={2}>
            <MDTypography variant="body2" color="text">
              Si cet email correspond à un compte, un lien de réinitialisation vient de vous être envoyé. Pensez à vérifier vos courriers indésirables.
            </MDTypography>
            <MDBox mt={3}>
              <Link to="/authentication/sign-in" style={{ textDecoration: "none" }}>
                <MDTypography variant="button" color="info">Retour à la connexion</MDTypography>
              </Link>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox display="flex" flexDirection="column" gap={2}>
            <MDTypography variant="body2" color="text">
              Saisissez votre adresse email, nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </MDTypography>
            <TextField
              label="Email"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            />
            {error && (
              <MDTypography variant="caption" color="error">{error}</MDTypography>
            )}
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Envoi..." : "Envoyer le lien"}
            </MDButton>
            <MDBox textAlign="center" mt={1}>
              <Link to="/authentication/sign-in" style={{ textDecoration: "none" }}>
                <MDTypography variant="caption" color="text">Retour à la connexion</MDTypography>
              </Link>
            </MDBox>
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
}

export default MotDePasseOublie;
